import { React, useState, useRef, useEffect, memo } from 'react'
import './Login.css'
import { motion, AnimatePresence, delay } from 'framer-motion'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Col, Row } from 'react-bootstrap';
import logo from '../Images/logo.png'
import UseCustomFormik from './formik';
import FormComponent from '../components/FormComponents/FormComponent';
import OtpInput from 'react-otp-input';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import LoadingScreen from '../LoadingScreen/LoadingScreen';
import BackEndUrl from '../backURL';
import axios from 'axios';
import loading from "../Images/three-dots.svg"
import { Avatar } from '@nextui-org/react';
import Lottie from 'react-lottie';
import tickAnimation from '../Images/Icons/tick-animation.json'
import errorAnimation from '../Images/Icons/error-animation.json'
import IconAnimation from '../components/IconAnimation/IconAnimation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';


const backend = BackEndUrl.domain
const desiredTimezone = 'Asia/Colombo';
function formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
}
const Login = () => {

    const [data, setData] = useState(null);
    const toast = useRef(null);
    const [step, setStep] = useState(1);
    const [otp, setOtp] = useState(''); //otp enterd be the user
    const [genOpt, setGenOpt] = useState(null); //generated otp
    const [countdown, Setcountdown] = useState(0);
    const [verified, setVerified] = useState(false)//to check whether req to generate the token is send
    const [otpLoaded, setotpLoaded] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false)
    const [visible, setVisible] = useState(false);
    const countDownInterval = useRef(null);
    const [isNicVerified, setIsNicVerified] = useState(null);
    const [isMobileVerified, setIsMobileVerified] = useState(null);
    const [Matched, setMatched] = useState(null);
  
    function handleKeyPress(event) {

        if (event.key === 'Enter') {
            OnclickSendOTP()
        }
    }

    async function CheckForOTP() {

        try {

            const response = await axios.post(backend + "/user-otp-check", {

                nic: sessionStorage.getItem("TempNIC") || "",
                mobile: sessionStorage.getItem("TempMobile") || "",


            }, {
                headers: {
                    Authorization: sessionStorage.getItem('token'),
                }
            });
            return response.data



        }
        catch (err) {
            console.log(err)

        }

    }
    useEffect(() => {

        async function CheckForAssignedOTP() {
            const existingValidOtp = await CheckForOTP();
            if (existingValidOtp.length != 0) {
                setGenOpt(existingValidOtp[0].otp)

                const otpSentTime = new Date(existingValidOtp[0].opt_sent_time);
                const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
                const timeDifferenceInMinutes = Math.floor(120 - ((currentTime - otpSentTime) / 1000));


                Setcountdown(timeDifferenceInMinutes)
                setIsLoaded(true)
                setotpLoaded(true)
                countingDown()
            } else {
                setIsLoaded(true)
            }

        }
        if (!genOpt && !countdown) {
            CheckForAssignedOTP()

        }


        if (formik.values.NIC) {
            isNIC(formik.values.NIC);
        }
        if (formik.values.Mobile) {
            isMobile(formik.values.Mobile);
        }
        if (formik.values.NIC && formik.values.Mobile) {
            isMatch(formik.values.Mobile, formik.values.NIC)
        }

    }, []);




    async function TokenCreation() {
        try {

            const response = await axios.post(backend + "/auth-token", {
                nic: formik.values.NIC,
                mobile: formik.values.Mobile,
            }
            )

            sessionStorage.setItem("token", response.data.token)
            sessionStorage.setItem('nic', formik.values.NIC)
            sessionStorage.setItem('mobile', formik.values.Mobile)
            sessionStorage.setItem('logged', 'ture')
            window.location.href = '/customer-portal/redirect'
        }
        catch (err) {
            console.log(err);
        }
    }
    //After the OTP is submited by the user 

    function OtpSubmition(value) {
        if (value == genOpt) {
            setVerified(true);

            TokenCreation();

        } else {


            toast.current.clear();
            toast.current.show({
                severity: 'error',
                summary: 'Invalid OTP',
                description: "Please Check the OTP"
                ,
                life: 3000,
                sticky: false,
                content: (props) => (
                    <div className="p-3" style={{ flex: '1' }}>
                        <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                        <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                    </div>
                ),
            });

        }
    }
    async function sendOtp() {

        try {

            const response = await axios.post(backend + "/user-otp", {

                nic: formik.values.NIC,
                mobile: formik.values.Mobile,

            }, {
                headers: {
                    Authorization: sessionStorage.getItem('token'),
                }
            });
            if (response.data) {
                toast.current.clear();
                toast.current.show({
                    severity: 'success',
                    summary: 'OTP Send Sucessfully',
                    description: "Check your mobile "
                    ,
                    life: 3000,
                    sticky: false,
                    content: (props) => (
                        <div className="p-3" style={{ flex: '1' }}>
                            <div className="" style={{ fontSize: "2.5dvh" }}>{props.message.summary}</div>
                            <div className="" style={{ fontSize: "2dvh" }}>{props.message.description}</div>
                        </div>
                    ),
                });
            }
            return (response.data)



        }
        catch (err) {
            console.log(err)

        }
    }
    //Cooling down the  OTP requests
    function countingDown() {

        if (countDownInterval.current) {
            clearInterval(countDownInterval.current);
        }
        countDownInterval.current = setInterval(() => {
            Setcountdown(prevCountdown => {
                if (prevCountdown > 0) {
                    return prevCountdown - 1;
                } else {
                    clearInterval(countDownInterval.current);
                    setGenOpt(null)
                    return 0;
                }
            });
        }, 1000);

    }
    async function isNIC(nic) {
        try {
            const response = await axios.post(backend + "/is-nic", {
                nic: nic,
            });

            if (response.data.isNIC > 0) {

                setIsNicVerified(true)
            }
            if (response.data.isNIC == 0) {
                setIsNicVerified(false)
            }


        }
        catch (err) {
            console.log(err)
        }
    }
    async function isMobile(mobile) {
        try {
            const response = await axios.post(backend + "/is-mobile", {
                mobile: mobile,
            });

            if (response.data.isMobile > 0) {

                setIsMobileVerified(true)
            }
            if (response.data.isMobile == 0) {
                setIsMobileVerified(false)
            }


        }
        catch (err) {
            console.log(err)
        }
    }
    async function isMatch(mobile, nic) {
        try {
            const response = await axios.post(backend + "/is-match", {
                mobile: mobile,
                nic: nic,
            });

            if (response.data.isMatch > 0) {

                setMatched(true)
            }
            if (response.data.isMatch == 0) {
                setMatched(false)
            }


        }
        catch (err) {
            console.log(err)
        }
    }
    async function OnclickSendOTP() {

        if (countdown == 0) {
            formik.validateForm().then(async (errors) => {
                sessionStorage.setItem("TempNIC", formik.values.NIC)
                sessionStorage.setItem("TempMobile", formik.values.Mobile)
                setOtp(null)
                if (Object.keys(errors).length === 0 && Matched == true && isMobileVerified == true && isNicVerified == true) {
                    const existingValidOtp = await CheckForOTP();

                    if (existingValidOtp.length == 0) {
                        const newOtp = await sendOtp()
                        setGenOpt(newOtp.otp)
                        setotpLoaded(true)

                        const otpSentTime = new Date(newOtp.otp_sent_time);
                        const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
                        const timeDifferenceInMinutes = Math.floor(120 - ((currentTime - otpSentTime) / 1000));
                        setStep(2)

                        Setcountdown(timeDifferenceInMinutes)
                        countingDown()
                    }
                    else {

                        setGenOpt(existingValidOtp[0].otp)
                        setotpLoaded(true)
                        const otpSentTime = new Date(existingValidOtp[0].opt_sent_time);
                        const currentTime = new Date(new Date().toLocaleString('en-US', { timeZone: desiredTimezone }));
                        const timeDifferenceInMinutes = Math.floor(120 - ((currentTime - otpSentTime) / 1000));
                        setStep(2)
                        Setcountdown(timeDifferenceInMinutes)
                        countingDown()
                    }
                }
            });
        }

        else {
            setStep(2)
            setOtp(null)
        }
    }

    function validtaionNIC(e) {
        var inputValue = e.target.value.toUpperCase();
        let filteredValue = "";
        const oneBeforeLastChar = inputValue.slice(-2, -1);

        if (inputValue.length < 10) {
            // Filter the input to allow only numbers, 'X', 'V', 'x', and 'v'
            setIsNicVerified(null)
            filteredValue = inputValue.replace(/[^0-9]/g, '');
            formik.setFieldValue("NIC", filteredValue);
        } else if (inputValue.length === 10 && (inputValue.endsWith('X') || inputValue.endsWith('V'))) {
            // If the length is 10 and ends with 'X' or 'V', update the state with the original input
            formik.setFieldValue("NIC", inputValue);
            filteredValue = inputValue;
            isNIC(inputValue)
            if (formik.values.Mobile) {
                isMatch(formik.values.Mobile, inputValue)
            }
        } else if (inputValue.length < 12 && (oneBeforeLastChar !== "X" && oneBeforeLastChar !== "V")) {
            // Filter the input to allow only numbers, 'X', 'V', 'x', and 'v'
            setIsNicVerified(null)
            filteredValue = inputValue.replace(/[^0-9XVxv]/g, '');
            formik.setFieldValue("NIC", filteredValue);
        } else if (inputValue.length === 12 && /^\d+$/.test(inputValue)) {
            // If the length is 12 and consists of only digits, update the state with the original input
            formik.setFieldValue("NIC", inputValue);
            filteredValue = inputValue;
            isNIC(inputValue)
            if (formik.values.Mobile) {
                isMatch(formik.values.Mobile, inputValue)
            }
        }
    }
    function validtaionMobile(e) {
        var inputValue = e.target.value;



        if (inputValue.length < 10) {

            setIsMobileVerified(null)
            formik.setFieldValue("Mobile", inputValue);
        } else if (inputValue.length === 10) {

            formik.setFieldValue("Mobile", inputValue);
            isMobile(inputValue)
            if (formik.values.NIC) {
                isMatch(inputValue, formik.values.NIC)
            }
        }
    }

    const optStyle = {
        width: "50px",
        height: "7vh",
        marginLeft: "0.5vw",
        marginRight: "0.5vw",
        borderRadius: "0.3em",
        border: "1px solid #f7931b",
        transition: "border-color 0.3s"

    }
    // sending the data for validation
    const formik = UseCustomFormik(step)

    //Auto submition of the OTP code
    function onchangeOtp(value) {
        if (value.length === 6) {
            OtpSubmition(value);
        }

        setOtp(value);

    }


    if (!sessionStorage.getItem('logged')) {

        return (


            <Row className='d-flex justify-content-center login-con align-items-center' >

                <Col xs={12} sm={10} md={9} lg={5}>

                    <Toast ref={toast} position="top-center" />
                    {step == 1 &&

                        // login page
                        <motion.div
                            onKeyDown={handleKeyPress}
                            initial={{
                                borderTopLeftRadius: "0em",
                                borderTopRightRadius: "40em",
                                borderBottomLeftRadius: "40em",
                                borderBottomRightRadius: "0em",
                                scale: 0.5,
                                opacity: 0,



                            }}
                            animate={{
                                opacity: 1,
                                borderTopLeftRadius: "0em",
                                borderTopRightRadius: "9em",
                                borderBottomLeftRadius: "9em",
                                borderBottomRightRadius: "0em",
                                scale: 1

                            }}



                            className='login-inner'>
                            <motion.div
                                initial={{

                                    opacity: 0

                                }}
                                animate={{
                                    opacity: 1

                                }}
                                exit={{
                                    opacity: 0

                                }}
                                transition={{ duration: 0.3 }}

                            >
                                <Row>
                                    <Col xs={2} className='logo-con mx-3 mt-2'>
                                        <img src={logo} className='logo' />
                                    </Col>

                                </Row>
                                <Row>
                                    <Col xs={12} className='d-flex justify-content-center'>
                                        <h4 className='title'><span style={{ color: "#00aaef" }}>Welcome To</span> <span style={{ color: "#f7941d" }}>Your Portal</span> </h4>
                                    </Col>
                                </Row>
                                <Row className='d-flex justify-content-center align-items-center form-container'>
                                    <Col xs={8} sm={9} md={8} lg={6}>
                                        <div className='mt-4'>
                                            <FormComponent
                                                type="input-alpha-group"
                                                label="NIC Number"
                                                value={formik.values.NIC}
                                                errors={formik.errors.NIC
                                                    ? formik.errors.NIC
                                                    : isNicVerified == false
                                                        ? "NIC does not exist"
                                                        : null}
                                                endContent={

                                                    <IconAnimation isVerified={isNicVerified} />


                                                }
                                                onChange={(e) => {
                                                    validtaionNIC(e)
                                                }}
                                                name={"NIC"}

                                                style={
                                                    {
                                                        height: "6vh",


                                                    }

                                                }

                                            />
                                            
                                            <FormComponent
                                                type="input-number-group"
                                                label="Mobile Number"
                                                value={formik.values.Mobile}
                                                onChange={(e) => {
                                                    validtaionMobile(e)

                                                }}
                                                name="Mobile"
                                                errors={formik.errors.Mobile
                                                    ? formik.errors.Mobile
                                                    : isMobileVerified == false
                                                        ? "NIC does not exist"
                                                        : Matched == false ? "Mobile Number does not Match" : null}
                                                endContent={

                                                    <IconAnimation isVerified={Matched === null || Matched === true ? isMobileVerified : Matched} />

                                                }

                                                style={
                                                    { height: "6vh" }
                                                }

                                            />

                                        </div>

                                    </Col>

                                </Row>

                                <Row className='d-flex justify-content-end mt-lg-5 mt-md-4 mt-sm-1 mt-1'>
                                    <Col xs={12} sm={12} md={9} lg={7} className='d-flex flex-row justify-content-center p-2 p-sm-2 p-md-2 p-lg-0'>
                                        <p className='me-lg-5'>Having Trouble?<a href='/customer-portal/contact-us' className='underline-link'> Contact Us</a></p>


                                    </Col>
                                    <Col xs={12} sm={12} md={9} lg={3} className='justify-content-lg-start justify-content-center justify-content-sm-center justify-content-md-center  d-flex'>

                                        {/* For large screens */}
                                        <motion.button
                                            whileTap={{ scale: 0.9 }}
                                            className={`btn btn-warning login-btn  d-none d-sm-none d-md-none d-lg-block `}

                                            onClick={() => { OnclickSendOTP() }}
                                            style={{ height: "120%" }}
                                        >
                                            <span className='d-flex flex-column' style={{ position: "relative" }}>

                                                <span> Login</span>


                                            </span>
                                        </motion.button>

                                        {/* For smaller screens */}
                                        <motion.button
                                            whileTap={{ scale: 0.9 }}
                                            className={`btn btn-warning login-btn d-block d-sm-block d-md-block d-lg-none  `}

                                            onClick={() => { OnclickSendOTP() }}
                                            style={{ height: "120%", width: "60%" }}
                                        >
                                            <span className='d-flex flex-column' style={{ position: "relative" }}>

                                                <span> Login</span>


                                            </span>
                                        </motion.button>
                                    </Col>
                                </Row>


                            </motion.div>


                        </motion.div>}





                    {step == 2 &&
                        // otp page
                        <motion.div
                            initial={{
                                borderTopLeftRadius: "0em",
                                borderTopRightRadius: "40em",
                                borderBottomLeftRadius: "40em",
                                borderBottomRightRadius: "0em",
                                scale: 0.5,
                                opacity: 0,




                            }}
                            animate={{
                                opacity: 1,
                                borderTopLeftRadius: "0em",
                                borderTopRightRadius: "9em",
                                borderBottomLeftRadius: "9em",
                                borderBottomRightRadius: "0em",
                                scale: 1,

                            }}
                            exit={
                                {
                                    opacity: 0


                                }
                            }
                            transition={{ duration: 0.3 }}


                            className='login-inner'>
                            <motion.div
                                initial={{

                                    opacity: 0

                                }}
                                animate={{
                                    opacity: 1

                                }}
                                exit={{
                                    opacity: 0

                                }}
                                transition={{ duration: 0.2 }}

                            >
                                <Row>
                                    <Col xs={2} className='logo-con mx-3 mt-2'>
                                        <img src={logo} className='logo' />
                                    </Col>

                                </Row>
                                <Row>
                                    <Col xs={12} className='d-flex justify-content-center '>

                                        <h3 className='opt-title'>Enter Verification Code</h3>
                                    </Col>
                                </Row>
                                <Row className='opt-con align-items-center justify-content-center' style={{ width: "100%", margin: 0 }}>

                                    <Col xs={12} className='d-flex justify-content-center align-items-center flex-column'>

                                        <Row className='d-flex justify-content-start'>
                                            <Col xs={12} style={{ textAlign: "" }} className='my-3'>
                                                {countdown > 0 ?
                                                    <p>Time Remaining {formatTime(countdown)}</p> :

                                                    <Message severity="error" style={{ textAlign: "center" }} text=" OTP expired" />

                                                }
                                            </Col>

                                        </Row>
                                        <OtpInput
                                         
                                            value={otp}
                                            onChange={(value) => onchangeOtp(value)}
                                            numInputs={6}
                                            renderSeparator={<span style={{ color: "#00adf1" }}>-</span>}
                                            renderInput={(props) => <input class={"opt-input"} {...props} type='number'/>}
                                            inputStyle={optStyle}


                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} className='d-flex justify-content-center'>
                                        <motion.button whileTap={{ scale: 0.9 }} className='btn  login-btn-blue mx-2' onClick={() => setStep(1)}>Back</motion.button>
                                        <motion.button
                                            whileTap={{ scale: 0.9 }}
                                            className={`btn login-btn mx-2 ${countdown > 0 ? 'disabled' : ''}`}
                                            disabled={countdown > 0 ? true : false}
                                            onClick={() => { OnclickSendOTP() }}
                                        >
                                            <span className='d-flex flex-column' style={{ position: "relative" }}>
                                                <span>Re Send</span>
                                                <span style={{ fontSize: "10px", position: "absolute", top: "70%", left: "40%" }}>{countdown > 0 && formatTime(countdown)}</span>

                                            </span>
                                        </motion.button>
                                        <motion.button whileTap={{ scale: 0.9 }} className='btn  login-btn-blue mx-2' onClick={() => { OtpSubmition(otp) }}>Next</motion.button>
                                    </Col>
                                </Row>

                                {verified &&
                                    <Row className='d-flex justify-content-center '>
                                        <img src={loading} className='m-5' style={{ width: "10%" }} />
                                    </Row>}
                            </motion.div>


                        </motion.div>}



                </Col>

            </Row>



        )


    }
    else {
        window.location.href = "/customer-portal/redirect"
    }
}

export default Login
